<template>
    <div class="profile-grid">
      <ModelPaidPictureCard
        v-for="(profile, index) in profiles"
        :key="index"
        :profile="profile"
        :locked="!isImageUnlocked(profile)"
        @view="openModal(index)"
        @subscribe="handleSubscribe"
        @likeImage="handleLikeImage(profile)"
      />

      <!-- IMAGE MODAL -->
      <transition name="fade">
        <div v-if="showModal" class="image-modal" @click.self="closeModal">
          <button class="close-btn" @click="closeModal">×</button>

          <!-- LEFT -->
          <button class="nav-btn left" @click="prevImage">
            ‹
          </button>

          <!-- IMAGE -->
          <img
            :src="currentProfile.image"
            class="modal-image"
            alt="preview"
          />

          <!-- RIGHT -->
          <button class="nav-btn right" @click="nextImage">
            ›
          </button>
        </div>
      </transition>

      <!-- Subscription Modal -->
      <transition name="fade">
        <div v-if="showSubscriptionModal" class="subs-backdrop">
          <div class="subs-modal">
            <!-- Header -->
            <div class="subs-header">
              <div>
                <h4 class="subs-title">
                  <i class="bi bi-credit-card"></i>
                  Unlock Content
                </h4>
                <p class="subs-subtitle">
                  Choose a subscription plan or make a one-time purchase
                </p>
              </div>

              <button class="subs-close" @click="showSubscriptionModal = false">×</button>
            </div>

            <!-- Body -->
            <div class="subs-body">
              <!-- One-time Purchase -->
              <div v-if="dayruns_token" class="one-time-box">
                <p class="one-time-text">One-time access</p>

                <button
                  class="btn btn-success one-time-btn"
                  @click="purchaseAssets(media_price, dayruns_token, asset_id)"
                >
                  <i class="fa fa-shopping-cart"></i>
                  Buy for {{ formatPrice(dayruns_token) }}{{ token_label }}
                </button>
              </div>

              <!-- Divider -->
              <div v-if="dayruns_token && services.length" class="divider">
                <span>OR</span>
              </div>

              <!-- Subscription Plans -->
              <div v-if="services.length" class="plans-section">
                <h5 class="plans-title">Subscription Plans</h5>

                <div class="plans-grid">
                  <div
                    class="plan-card"
                    v-for="(service, index) in services"
                    :key="index"
                  >
                    <div class="plan-header">
                      <h6>{{ service.category }}</h6>
                    </div>

                    <div class="plan-body">
                      <p class="plan-price">
                        {{ service.dayruns_token }}{{ token_label }}
                      </p>
                      <p class="plan-duration">
                        {{ service.duration ? service.duration + ' days' : 'Unlimited' }}
                      </p>
                    </div>

                    <button
                      class="btn btn-success w-100"
                      :disabled="service.enabled !== 'true'"
                      @click="bookService(service)"
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>

              <!-- Empty State -->
              <div v-if="!services.length && !media_price" class="empty-state">
                <i class="bi bi-emoji-frown"></i>
                <p>No subscription plans available</p>
              </div>
            </div>

            <!-- Footer -->
            <div class="subs-footer">
              <button class="btn btn-outline-secondary" @click="showSubscriptionModal = false;">
                Close
              </button>
            </div>
          </div>
        </div>
      </transition>

    </div>
  </template>
<script>
import ModelPaidPictureCard from "./ModelPaidPictureCard.vue";

export default {
  name: "ModelPaidPictureGrid",
  components: { ModelPaidPictureCard },
  props: {
    profiles: Array
  },
  data() {
    return {
      showModal: false,
      showSubscriptionModal: false,
      currentIndex: 0,
      media_price: null,
      dayruns_token: '',
      asset_id: null,
      services: [],
      logoutSplash: false,
      userid: '',
      escortid: '',
      selectedPlan: '',
      selectedFee: '',
      selectedId: '',
      payment_service: [],
      payment_ref: '',
      user_email: '',
      apikey: '',
      active_purchases: [],
      active_subscriptions: false,
      locked: false,
      token_label: process.env.VUE_APP_TOKEN_LABEL,
    };
  },
  computed: {
    currentProfile() {
      return this.profiles[this.currentIndex];
    }
  },
  watch: {
      profiles: {
      immediate: true,
      handler(newProfiles) {
        if (newProfiles && newProfiles.length) {
          const escort_user_id = newProfiles[0].escort_user_id;
          const escortId = newProfiles[0].userid;

          this.fetchClientActiveSubscription(
            escort_user_id,
            this.userid
          );

          this.fetchActivePurchases(escortId);
        }
      }
    }
  },
  async beforeMount(){ 
    await this.getConfigData()

    const user = localStorage.getItem("userid");
    if (user) {
      this.userid = user;
    }

    if (this.profiles.length) {
      const escort_user_id = this.profiles[0].escort_user_id;
      const escortId = this.profiles[0].userid;
      this.fetchClientActiveSubscription(escort_user_id, this.userid )
      this.fetchActivePurchases(escortId);
    }
  },
  async mounted() {

    const user = localStorage.getItem("userid");

    const email = localStorage.getItem("email");
    if (user) {
      this.user_email = email;
    }

    window.addEventListener("keydown", this.handleKey);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {

    async handleLikeImage(image) {
    try {
        if (!this.userid) {

          setTimeout(() => {
          this.$router.push("/login")
          }, 500); // splash visible for 5 seconds
          return;
        }

        const response = await this.$http.post('/like-photo', {
          image_id: image.id,
          liked_by: this.userid,
          escort_id: image.userid,
        });

        if (response.data.success) {
        
        // refresh like count instantly
        image.likes = response.data.likes;

        // Set splash message
        this.logoutMessage = response.data.message || "Like Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
        this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds

        } else {

          // Set splash message
          this.logoutMessage = response.data.message || "Unable to like picture.";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        }
      
    } catch (err) {
      console.error(err);
    }
    },
    async fetchServices(escortid) {
      try {
        const response = await this.$http.get(`/list-subscription-plans/${escortid}`);
        if (response.data.success) {
          this.services = response.data.data;
        } else {
          this.logoutMessage = response.data.message || "Failed to load services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
      } catch (err) {
        console.error(err);
        this.logoutMessage = "An error occurred while fetching services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
      }
    },
    async purchaseAssets(price, dayruns_token, asset_id) {
    try {
      // Add confirmation alert before proceeding
      const confirmed = confirm("Are you sure you want to buy this asset?");
      if (!confirmed) return; // Stop execution if user cancels

      const response = await this.$http.post('/create-media-purchase', {
        client_id: this.userid,  // client id
        model_id: this.escortid,  // model id
        asset_id: asset_id,
        amount: price,
        dayruns_token: dayruns_token
      });

      if (response.data.success) {
        // Set splash message
        this.active_purchases.push(this.asset_id);
        this.showSubscriptionModal = false;

        alert(response.data.message || "Image unlocked successfully!");

        return;
      }
    } catch (err) {
      this.truthdare_status = false;
      alert(err.response ? err.response.data.message : err.message);
    }
    },
    async bookService(service){
      try {
        if (!this.userid) {
          // Set splash message
          this.logoutMessage = "Please login to subscribe for this plan!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
        }

        const confirmed = confirm("Proceed to subscribe?");
        if (!confirmed) return; // Stop execution if user cancels
        
        this.showSubscriptionModal = false
        this.selectedFee = service.price
        this.selectedPlan = service.category
        this.selectedId = service.id
        this.payment_service = service

        const payment_reference = "PAY-" + Date.now();
        
        this.pay(this.userid, this.payment_service, payment_reference)
        
    } catch (err) {
      console.error(err);
      
    }
    },
    async fetchClientActiveSubscription(escortid, user_id) {
      try {
        const response = await this.$http.get(`/get-active-subscriptions/${escortid}/${user_id}`);
        if (response.data.success) {
          const services = response.data.data;
          // Check if services is not null/undefined and has at least one record
          if (services && Array.isArray(services) && services.length > 0) {
            this.active_subscriptions = true;
          } else {
            this.active_subscriptions = false;
          }
        } 
      } catch (err) {
        console.error(err);
      }
    },
    async fetchActivePurchases(escortid) {
    if (!this.userid) return;

    try {
        const response = await this.$http.get(
          `/get-active-purchases/${escortid}/${this.userid}`
        );

        if (response.data.success) {
          this.active_purchases = response.data.data.map(i => i.asset_id);
        }
      } catch (err) {
        console.error(err);
        this.active_purchases = [];
      }
    },
    isImageUnlocked(profile) {
      // Free image
      if (!profile.dayruns_token || profile.dayruns_token === 0) return true;

      // Subscription unlocks all
      if (this.active_subscriptions) return true;

      // One-time purchase
      return this.active_purchases.includes(profile.id);
    },
    async pay(user_id, payment_service, payment_reference) {
        try{
          const response = await this.$http.post('/book-escort-service', {
            user_id: user_id,
            service: payment_service,
            payment_reference: payment_reference
          });

        if (response.data.success) {
        // Set splash message
        this.logoutMessage = response.data.message || "Payment Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
            this.logoutSplash = false
            this.showSubscriptionModal = false;
            alert(`Plan "${this.selectedPlan}" activated!`);    
            window.location.reload();
        }, 2500); // splash visible for 2.5 seconds

        } else {

          // Set splash message
          this.logoutMessage = response.data.message || "Unable to Process.";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
            
        }catch (err) {
          console.log(err);
      }

    },
    async getConfigData(){
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.apikey = configData.apikey;
    },
    formatPrice(value) {
      return new Intl.NumberFormat('en-NG', {
      minimumFractionDigits: 0
    }).format(value);
    },
    openModal(index) {
      const profile = this.profiles[index];

      if (!this.isImageUnlocked(profile)) {
        this.handleSubscribe(profile);
        return;
      }

      this.currentIndex = index;
      this.locked = this.profiles[index].locked
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    handleSubscribe(profile) {
      this.escortid = profile.userid;
      this.fetchServices(profile.userid);
      this.fetchActivePurchases(profile.userid);
      this.openSubscription(profile.price, profile.dayruns_token, profile.id);
    },
    openSubscription(price, dayruns_token, asset_id) {
    if (!this.userid) {
          // Set splash message
          this.logoutMessage = "Please login to subscribe!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
    }
    this.media_price = price
    this.dayruns_token = dayruns_token
    this.asset_id = asset_id
    this.showSubscriptionModal = true;
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = "";
    },
    nextImage() {
    let nextIndex = this.currentIndex;

    do {
      nextIndex = (nextIndex + 1) % this.profiles.length;
    } while (
      this.profiles[nextIndex].locked && 
      nextIndex !== this.currentIndex
    );

    // stop if next is locked and no unlocked found
    if (!this.profiles[nextIndex].locked) {
      this.currentIndex = nextIndex;
    }
    },
    prevImage() {
    let prevIndex = this.currentIndex;

    do {
      prevIndex =
        (prevIndex - 1 + this.profiles.length) %
        this.profiles.length;
    } while (
      this.profiles[prevIndex].locked &&
      prevIndex !== this.currentIndex
    );

    if (!this.profiles[prevIndex].locked) {
      this.currentIndex = prevIndex;
    }
    },
    handleKey(e) {
      if (!this.showModal) return;
      if (e.key === "ArrowRight") this.nextImage();
      if (e.key === "ArrowLeft") this.prevImage();
      if (e.key === "Escape") this.closeModal();
    }
  },
  
};
</script>

<style lang="scss" scoped>
.modal-maskp {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .4s ease;
  
  & > div {
      width: 80%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //padding: 2em;
      border: 0.5px solid #D33E74;
      background: #19181B;
      border-radius: 20px;
      box-sizing: border-box;
  }
.player-title{
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 42px;
  text-align: center;
  color: #FFFFFF;
}
.amount {
  display: flex;
  flex-direction: row;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  color: #FFFFFF;
  justify-content: space-between;
  .fees {
      
  }
  .price {
  
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 27px;
      color: #D33E74;
  }
}
.payment-option{
  display: flex; 
  flex-direction: row; 
}
.payment-types {
  width: 388px;
  height: 254px;
  background: #272528;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom:20px;
  font-family: 'Nunito';
  font-style: normal;
  .payhow{
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 10px;
      letter-spacing: -0.02em;
      color: #FFFFFF;
      text-align: center;
      margin-top: 10px;
  }
  .payment{
      margin:15px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px 14px;
      width: 314px;
      height: 46px;
      background: #19181B;
      border-radius: 4px;
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 22px;
      letter-spacing: -0.02em;
      color: #FFFFFF;
  }

  h3{
      font-family: 'DM Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 42px;
      text-align: center;
      color: #0A070F;
  }
  
  
}
.player-payinfo{
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  color: #FFFFFF;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.player-button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px;
  height: auto;
  width: 40px;
  background: #333;
  border-radius: 5px;
  font-family: 'Source Sans 3';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #FFFFFF;
  margin-top: 10px;
  margin-bottom: 30px;
  //display: block;
  margin-left: auto;
  margin-right: auto;
}   
}
.profile-grid {
display: grid;
grid-template-columns: repeat(6, 1fr); /* 🖥 Desktop: 6 columns */
gap: 20px;
}

/* 📲 Tablets (iPad portrait & landscape) */
@media (max-width: 1024px) {
.profile-grid {
    grid-template-columns: repeat(4, 1fr);
}
}

/* 📱 Mobile */
@media (max-width: 768px) {
.profile-grid {
  grid-template-columns: repeat(2, 1fr); /* 2 columns */
  gap: 10px;
  padding-right: calc(var(--bs-gutter-x) * .0);
  padding-left: calc(var(--bs-gutter-x) * .0);
}
}

.image-modal {
position: fixed;
inset: 0;
background: rgba(0, 0, 0, 0.92);
display: flex;
align-items: center;
justify-content: center;
z-index: 9999;
}

.modal-image {
  width: auto;
  height: 100%;
  border-radius: 6px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
}
@media (max-width: 768px) {
  .modal-image {
    width: 95%;
    height: 70%;
    border-radius: 6px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
    overflow-y: scroll;
  }
}
.close-btn {
  position: absolute;
  top: 25px;
  right: 30px;
  font-size: 34px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
}

.nav-btn {
position: absolute;
top: 50%;
transform: translateY(-50%);
font-size: 60px;
background: none;
border: none;
color: #fff;
cursor: pointer;
padding: 10px;
opacity: 0.85;
}

.nav-btn:hover {
opacity: 1;
}

.nav-btn.left {
left: 20px;
}

.nav-btn.right {
right: 20px;
}

/* Fade animation */
.fade-enter-active,
.fade-leave-active {
transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
opacity: 0;
}

.subs-backdrop {
position: fixed;
inset: 0;
background: rgba(0, 0, 0, 0.75);
z-index: 9999;
display: flex;
align-items: center;
justify-content: center;
width: 100%;
height: 100%;
}

.subs-modal {
width: 90%;
max-width: 600px;
background: #fff;
border-radius: 14px;
box-shadow: 0 25px 80px rgba(0, 0, 0, 0.35);
max-height: 80vh;   /* limit height */
overflow: hidden;   /* prevent outside scroll */
}

.subs-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 20px 24px;
background: linear-gradient(135deg, #D33E74, #D33E74);
color: #fff;
}

.subs-title {
margin: 0;
font-weight: 600;
}

.subs-subtitle {
font-size: 13px;
opacity: 0.85;
}

.subs-close {
font-size: 28px;
background: none;
border: none;
color: #fff;
cursor: pointer;
}

/* Scrollable body */
.subs-body {
  padding: 15px;
  overflow-y: auto;     /* 👈 scroll enabled */
  -webkit-overflow-scrolling: touch; /* smooth iOS scroll */
  padding: 30px 24px;
}

/* Mobile optimization */
@media (max-width: 768px) {
  .subs-modal {
    max-height: 80vh;
    border-radius: 10px;
    overflow: scroll;   /* prevent outside scroll */
  }

  .plans-grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* 2 grids on mobile */
    gap: 10px;
  }
}

/* Extra small phones */
@media (max-width: 480px) {
  .plans-grid {
    grid-template-columns: 1fr; /* 1 per row if too tight */
  }
}
.one-time-box {
background: #f0fdf4;
border: 1px solid #bbf7d0;
padding: 20px;
border-radius: 12px;
text-align: center;
}

.one-time-text {
font-weight: 600;
margin-bottom: 10px;
}

.btn-success{
  background: #D33E74;
  border: solid 0px;
}
.btn-success:hover{
  background: #D33E74;
}

.one-time-btn {
font-size: 14px;
padding: 10px 18px;
}

.divider {
text-align: center;
margin: 30px 0;
position: relative;
}

.divider span {
background: #fff;
padding: 0 14px;
font-weight: 600;
color: #6b7280;
}

.divider::before {
content: "";
position: absolute;
inset: 50% 0 auto 0;
height: 1px;
background: #e5e7eb;
z-index: -1;
}

.plans-title {
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Desktop */
  gap: 15px;
  margin-top: 10px;
}

/* Tablet */
@media (max-width: 992px) {
  .plans-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile → Force 2 columns */
@media (max-width: 576px) {
  .plans-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

.plan-card {
border: 1px solid #e5e7eb;
border-radius: 14px;
padding: 20px;
display: flex;
flex-direction: column;
transition: all 0.25s ease;
}

.plan-card:hover {
transform: translateY(-4px);
box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.plan-header h6 {
font-weight: 600;
margin-bottom: 10px;
text-transform: capitalize;
}

.plan-price {
font-size: 22px;
font-weight: 700;
margin-bottom: 4px;
}

.plan-duration {
font-size: 13px;
color: #6b7280;
margin-bottom: 18px;
}

.empty-state {
text-align: center;
color: #9ca3af;
padding: 40px 0;
}

.empty-state i {
font-size: 40px;
margin-bottom: 10px;
}

.subs-footer {
padding: 16px 24px;
background: #f9fafb;
text-align: right;
}


</style>
